import Button from 'components/Button/Button';
import styles from './CheckInList.module.scss';
import { date2usDotDateTime, date2usSlashDateTime } from 'helpers';
import { ReactComponent as ExpandIcon } from "assets/expand.svg";
import { CheckInItem } from 'types';
import { ReactComponent as CheckIcon } from "assets/verified.svg";
import { Center, Loader } from '@mantine/core';

interface ICheckInListProps {
  checkIns: CheckInItem[] | undefined;
  onCheckInClick: (checkIn: CheckInItem) => void;
  addNewCheckIn: () => void;
}

const CheckInList = ({checkIns, onCheckInClick, addNewCheckIn}: ICheckInListProps) => {
  const renderCheckIn = (index: number, checkIn: CheckInItem) => {


    return (
      <div key={checkIn.id} className={styles.checkInItem}  onClick={() => onCheckInClick(checkIn)}>
        <div className={styles.checkInItemContent}>
        <div className={styles.checkInItemHeader}>
          <p className={styles.checkinNumber}>{index + 1}. </p>
          {/*<p className={styles.paragraph}>{date2usSlashDateTime(checkIn.created_at)}</p>*/}
          
          <p className={styles.paragraph}>
            {date2usSlashDateTime(
              checkIn.created_at,
              checkIn.is_archived
                ? 'GMT'
                : checkIn.is_archived_bg
                ? 'America/New_York'
                : undefined
            )}
          </p>
          <CheckIcon className={`${styles.checkIcon} ${!checkIn.verified && styles.unverified}`} />
          {checkIn.is_archived && (
            <span className={styles.exportedBadge}>FROM BADGER</span>
          )}
          {checkIn.is_archived_bg && (
            <span className={styles.exportedBadge}>FROM BADGER</span>
          )}
        </div>
        <p className={styles.fmcName}>{checkIn.user_name}</p>
        <p className={styles.notes}>
          {checkIn.notes.length > 150 ? `${checkIn.notes.slice(0, 150)}...` : checkIn.notes}
        </p>
        </div>
        <div className={styles.iconWrapper}>          
          <ExpandIcon/>
        </div>
      </div>
    )
  }

  return(
    <div className={styles.wrapper}>
      <div className={styles.headerWrapper}>
        You have a total of {checkIns?.length || 0} check-ins
        <Button textColor="white" color="#00C542" borderColor="#00C54280" type="outline" onClick={addNewCheckIn}>CHECK-IN</Button>
      </div>
      {!checkIns ? (
        <Center>
          <Loader />
        </Center>
      ): (
        <>
        {/* Warning message if any check-in is archived */}
        {checkIns.some(checkIn => checkIn.is_archived || checkIn.is_archived_bg) && (
          <div className={styles.warningMessage}>
            Imported check-in's may contain wrong times & duplicates.
          </div>
        )}

        <div className={styles.checkInListWrapper}>
          {checkIns.map((checkIn, index) => {
            return renderCheckIn(index, checkIn)
          })}  
        </div>
        </>
      )}

      
    </div>
  )
}

export default CheckInList;